import { ObjectAnyType } from '@/types/generic'
import { DatabaseItemRecordType, DatabaseStoreType } from '@/types/idb'

const DATABASE_NAME = 'RealTimeDashboard'
const DATABASE_TABLE_NAME = 'Main'
const VERSION = 1

class IndexDatabaseService {
    private _db?: IDBDatabase

    async getDatabase (): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            if (this._db) {
                resolve(this._db)
            }

            const request = window.indexedDB.open(DATABASE_NAME, VERSION)

            request.onerror = event => {
                console.error('ERROR: Unable to open database', event)
                reject('Error')
            }

            request.onsuccess = (event: ObjectAnyType) => {
                this._db = event.target?.result as IDBDatabase
                resolve(this._db)
            }

            request.onupgradeneeded = (event: ObjectAnyType) => {
                const database = event.target.result
                database?.createObjectStore(DATABASE_TABLE_NAME, {
                    autoIncrement: false,
                    keyPath: 'key'
                })
            }
        })
    }

    async getDatabaseStore (): Promise<DatabaseStoreType> {
        this._db = await this.getDatabase()
        return new Promise((resolve, reject) => {
            const transaction = this._db?.transaction(DATABASE_TABLE_NAME, 'readonly') as IDBTransaction
            const store = transaction?.objectStore(DATABASE_TABLE_NAME) as IDBObjectStore

            const globalList = [] as DatabaseStoreType

            store.openCursor().onsuccess = (event: ObjectAnyType) => {
                const cursor = event.target.result
                if (cursor) {
                    globalList.push(cursor.value)
                    cursor.continue()
                }
            }

            transaction.oncomplete = () => {
                resolve(globalList)
            }
            transaction.onerror = event => {
                reject(event)
            }
        })
    }

    async setObjectToStore (data: DatabaseItemRecordType) {
        this._db = await this.getDatabase()
        return new Promise((resolve, reject) => {
            const transaction = this._db?.transaction(DATABASE_TABLE_NAME, 'readwrite') as IDBTransaction
            const store = transaction.objectStore(DATABASE_TABLE_NAME) as IDBObjectStore

            store.put(data)

            transaction.oncomplete = () => {
                resolve(true)
            }
            transaction.onerror = event => {
                reject(event)
            }
        })
    }

    async clearAllStore () {
        this._db = await this.getDatabase()
        return new Promise((resolve) => {
            const transaction = this._db?.transaction(DATABASE_TABLE_NAME, 'readwrite') as IDBTransaction
            transaction.objectStore(DATABASE_TABLE_NAME).clear()
            transaction.oncomplete = () => {
                resolve(true)
            }
        })
    }

    async removeObjectFromStore (key: string) {
        this._db = await this.getDatabase()
        return new Promise((resolve, reject) => {
            const transaction = this._db?.transaction(DATABASE_TABLE_NAME, 'readwrite') as IDBTransaction
            const store = transaction.objectStore(DATABASE_TABLE_NAME) as IDBObjectStore

            store.delete(key)

            transaction.oncomplete = () => {
                resolve(true)
            }
            transaction.onerror = event => {
                reject(event)
            }
        })
    }
}

export default new IndexDatabaseService()
